export default theme => ({
  root: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      height: 650,
      maxHeight: 650
    },
    [theme.breakpoints.up("sm")]: {
      height: 536,
      maxHeight: 536
    }
  },

  root2: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      height: 350,
      maxHeight: 350
    },
    [theme.breakpoints.up("sm")]: {
      height: 350,
      maxHeight: 350
    }
  },

  rootMobile: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      height: 250,
      maxHeight: 250
    },
    [theme.breakpoints.only("md")]: {
      height: 300,
      maxHeight: 300
    },
    [theme.breakpoints.up("lg")]: {
      height: 536,
      maxHeight: 536
    }
  },

  imageContent: {
    [theme.breakpoints.up(0)]: {
      backgroundImage: ({ pathImage }) => `url(${pathImage})`,
      backgroundColor: "transparent",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }
  },

  gradient: {
    backgroundImage: ({ pathImage }) =>
      `linear-gradient(270deg, #FFFFFF00 0%, #36363654 100%), url(${pathImage})`
  },

  container: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
      paddingRight: 0
    },
    [theme.breakpoints.up("lg")]: {
      justifyContent: "space-between"
    }
  }
});
